import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { cn } from "@/modern/utils";

interface FileCollectionNavButtonsProps {
  filesCount: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void | Promise<void>;
  isLoadingMore?: boolean;
  variant?: "inline" | "overlay";
}

const overlayButtonClass =
  "pointer-events-auto size-8 rounded-full border border-border !bg-background !text-foreground shadow-lg hover:!opacity-90 disabled:pointer-events-none disabled:!opacity-50";

export const FileCollectionNavButtons = ({
  filesCount,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  isLoadingMore = false,
  variant = "inline",
}: FileCollectionNavButtonsProps) => {
  if (filesCount <= 1 && !hasNext) {
    return null;
  }

  if (variant === "overlay") {
    return (
      <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-between px-2">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn(overlayButtonClass, "shrink-0")}
          onClick={onPrevious}
          disabled={!hasPrevious}
          aria-label="Previous file"
        >
          <ChevronLeft className="size-5" />
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn(overlayButtonClass, "shrink-0")}
          onClick={() => void onNext()}
          disabled={!hasNext || isLoadingMore}
          aria-label="Next file"
        >
          <ChevronRight className="size-5" />
        </Button>
      </div>
    );
  }

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={onPrevious}
        disabled={!hasPrevious}
        aria-label="Previous file"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => void onNext()}
        disabled={!hasNext || isLoadingMore}
        aria-label="Next file"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </>
  );
};
